"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TypesTreeView;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
const typesTreeApi_1 = require("./typesTreeApi");
const AddTypeModal_1 = require("./AddTypeModal");
const typesTreeModel_1 = require("./typesTreeModel");
const typesTreeLayout_1 = require("./typesTreeLayout");
const TypesTreeGraph_1 = require("./TypesTreeGraph");
/** Stan wyjściowy widoku: całe drzewo rozwinięte, zadania widoczne, zero wyjątków. */
const DEFAULT_DEPTH = "subCases";
const DEPTH_LABELS = [
    { value: "milestones", label: "kamienie" },
    { value: "cases", label: "sprawy" },
    { value: "subCases", label: "podsprawy" },
];
/** „3 z 25 spraw" albo „5 kamieni", gdy nic nie schowano. */
function countPhrase(visible, total, one, few, many) {
    const noun = (0, typesTreeLayout_1.pluralPl)(total, one, few, many);
    return visible === total ? `${total} ${noun}` : `${visible} z ${total} ${noun}`;
}
function summaryText(summary) {
    const parts = [
        // Kolumna typów umów zajmuje jedną czwartą szerokości widoku - zdanie,
        // które ją przemilcza, opisuje inny obraz niż ten na ekranie.
        countPhrase(summary.contractTypes.visible, summary.contractTypes.total, "typ umowy", "typy umów", "typów umów"),
        countPhrase(summary.milestoneTypes.visible, summary.milestoneTypes.total, "kamień", "kamienie", "kamieni"),
        countPhrase(summary.caseTypes.visible, summary.caseTypes.total, "sprawa", "sprawy", "spraw"),
        countPhrase(summary.subCaseTypes.visible, summary.subCaseTypes.total, "podsprawa", "podsprawy", "podspraw"),
        countPhrase(summary.tasks.visible, summary.tasks.total, "zadanie", "zadania", "zadań"),
    ];
    return `widać: ${parts.join(" · ")}`;
}
/**
 * Podgląd hierarchii typów: umowa → kamień milowy → sprawa → podsprawa.
 *
 * Na razie tylko do odczytu. Edycja powiązań czeka na uporządkowanie zapisu
 * po stronie backendu - te powiązania sterują strukturą folderów zakładanych
 * na Dysku przy nowej umowie, więc zapis musi być pewny, zanim trafi do interfejsu.
 */
function TypesTreeView({ title }) {
    const [data, setData] = (0, react_1.useState)(typesTreeModel_1.EMPTY_TREE);
    const [selectedContractTypeId, setSelectedContractTypeId] = (0, react_1.useState)(null);
    const [selectedNodeId, setSelectedNodeId] = (0, react_1.useState)(null);
    const [error, setError] = (0, react_1.useState)(null);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [addKind, setAddKind] = (0, react_1.useState)(null);
    const [editTarget, setEditTarget] = (0, react_1.useState)(null);
    // Zadania startowe widoczne od razu - to one są powodem tej przebudowy.
    // Przełącznik istnieje po to, żeby dało się je schować, a nie żeby ich szukać.
    const [showTasks, setShowTasks] = (0, react_1.useState)(true);
    // Poziom ustawia STAN WYJŚCIOWY całego drzewa, chevron robi od niego wyjątek.
    const [depth, setDepth] = (0, react_1.useState)(DEFAULT_DEPTH);
    const [expanded, setExpanded] = (0, react_1.useState)({});
    // Szuflady spoza gałęzi: informacja z pierwszego kontaktu z widokiem („co odbiega
    // od reszty"), nie codzienna - domyślnie zwinięte, żeby drzewo dostało miejsce.
    const [showExtras, setShowExtras] = (0, react_1.useState)(false);
    const [showLegend, setShowLegend] = (0, react_1.useState)(false);
    // Edycja tylko dla panelu administracyjnego. Reszta pracowników ENVI ogląda.
    // Ta sama granica stoi w backendzie (zapis pod /admin) - tutaj chodzi o to, żeby
    // widok nie proponował czegoś, co i tak skończy się odmową.
    const canEdit = MainSetupReact_1.default.isRoleAllowed(MainSetupReact_1.default.ADMIN_PANEL_ROLES);
    const [isSaving, setIsSaving] = (0, react_1.useState)(false);
    const [saveError, setSaveError] = (0, react_1.useState)(null);
    async function handleSave(kind, payload, editedId) {
        setIsSaving(true);
        setSaveError(null);
        try {
            let tree;
            if (editedId !== undefined) {
                tree =
                    kind === "milestoneType"
                        ? await (0, typesTreeApi_1.editMilestoneType)(editedId, payload)
                        : await (0, typesTreeApi_1.editCaseType)(editedId, payload);
            }
            else if (kind === "attachMilestoneType") {
                // Podpięcie istniejącego typu nie tworzy typu, więc nie ma tu `editedId`
                // ani ścieżki edycji - to własna operacja, nie odmiana dodawania.
                tree = await (0, typesTreeApi_1.attachMilestoneType)(payload);
            }
            else {
                tree = kind === "milestoneType" ? await (0, typesTreeApi_1.addMilestoneType)(payload) : await (0, typesTreeApi_1.addCaseType)(payload);
            }
            setData(tree);
            setAddKind(null);
            setEditTarget(null);
        }
        catch (caught) {
            setSaveError(caught instanceof Error ? caught.message : "Nie udało się zapisać.");
        }
        finally {
            setIsSaving(false);
        }
    }
    /** Klik w prostokąt otwiera edycję typu kamienia albo typu sprawy. */
    function openEditFor(nodeId) {
        const [nodeKind, rawId] = nodeId.split(":");
        const id = Number(rawId);
        if (nodeKind === "milestoneType") {
            const entity = data.milestoneTypes.find((type) => type.id === id);
            if (entity) {
                setSaveError(null);
                setEditTarget({ kind: "milestoneType", entity });
            }
            return;
        }
        if (nodeKind === "caseType" || nodeKind === "subCaseType") {
            const entity = data.caseTypes.find((type) => type.id === id);
            if (entity) {
                setSaveError(null);
                setEditTarget({ kind: "caseType", entity });
            }
        }
    }
    (0, react_1.useEffect)(() => {
        document.title = title;
    }, [title]);
    (0, react_1.useEffect)(() => {
        let isActive = true;
        (async () => {
            try {
                const tree = await (0, typesTreeApi_1.fetchTypesTree)();
                if (!isActive)
                    return;
                setData(tree);
                const firstActive = tree.contractTypes.find((type) => type.status !== "OLD") ?? tree.contractTypes[0];
                setSelectedContractTypeId(firstActive ? firstActive.id : null);
            }
            catch (caught) {
                if (isActive)
                    setError(caught instanceof Error ? caught.message : "Nieznany błąd.");
            }
            finally {
                if (isActive)
                    setIsLoading(false);
            }
        })();
        return () => {
            isActive = false;
        };
    }, []);
    const layout = (0, react_1.useMemo)(() => (0, typesTreeLayout_1.layout)(data, selectedContractTypeId, { showTasks, depth, expanded }), [data, selectedContractTypeId, showTasks, depth, expanded]);
    /**
     * Chevron zapisuje wyjątek tylko wtedy, gdy faktycznie odbiega od poziomu.
     * Powrót do stanu zgodnego z poziomem kasuje wpis, więc „Zresetuj widok"
     * nie świeci się, kiedy nie ma czego resetować.
     */
    function toggleCollapse(node) {
        const next = !node.isExpanded;
        setExpanded((current) => {
            const updated = { ...current };
            if (next === (0, typesTreeLayout_1.isExpandedByDepth)(node.kind, depth))
                delete updated[node.id];
            else
                updated[node.id] = next;
            return updated;
        });
    }
    /** Zmiana poziomu to nowy stan wyjściowy - wcześniejsze wyjątki przestają obowiązywać. */
    function changeDepth(next) {
        setDepth(next);
        setExpanded({});
    }
    /**
     * Przełączenie typu umowy to inna gałąź, więc wyjątki chevronów nie mają się
     * do czego odnosić - kasujemy je razem z zaznaczeniem węzła. Poziom zostaje:
     * mówi, jak głęboko użytkownik chce patrzeć, a nie na co patrzy.
     */
    function selectContractType(contractTypeId) {
        if (contractTypeId === selectedContractTypeId)
            return;
        setSelectedContractTypeId(contractTypeId);
        setSelectedNodeId(null);
        setExpanded({});
        // Panel pokazywał typ z gałęzi, której już nie widać - zostawiony otwarty
        // opisywałby coś, czego nie ma na ekranie.
        setEditTarget(null);
    }
    function resetView() {
        setDepth(DEFAULT_DEPTH);
        setExpanded({});
        setShowTasks(true);
    }
    const isViewChanged = depth !== DEFAULT_DEPTH || Object.keys(expanded).length > 0 || !showTasks;
    const orphanMilestones = (0, react_1.useMemo)(() => (0, typesTreeModel_1.unassignedMilestoneTypes)(data), [data]);
    const orphanCaseTypes = (0, react_1.useMemo)(() => (0, typesTreeModel_1.caseTypesWithoutMilestone)(data), [data]);
    const offerBranch = (0, react_1.useMemo)(() => (0, typesTreeModel_1.offerMilestoneTypes)(data), [data]);
    if (isLoading)
        return (react_1.default.createElement("div", { className: "p-4 text-center" },
            react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border" })));
    if (error)
        return react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, error);
    const isPanelOpen = editTarget !== null;
    const selectedContractType = data.contractTypes.find((type) => type.id === selectedContractTypeId);
    const selectedMilestoneTypeId = selectedNodeId && selectedNodeId.startsWith("milestoneType:")
        ? Number(selectedNodeId.split(":")[1])
        : null;
    return (
    // Container fluid, a nie zwykły div z paddingiem: Row ma ujemne marginesy
    // po 12 px z każdej strony i bez kompensacji wypycha stronę w poziomie.
    // Otwarty panel ZWĘŻA obszar widoku o swoją szerokość, zamiast położyć się
    // na drzewie: kontener drzewa dostaje mniej miejsca, a płótno przelicza się
    // na nową szerokość, więc nic nie chowa się pod panelem.
    //
    // Zwężamy SZEROKOŚĆ, nie padding i nie margines: `container-fluid` ma
    // `width: 100%`, więc margines nic by nie ujął, a padding zjadłby te 12 px,
    // które kontener i tak trzyma po prawej (obszar spadłby o 340, nie o 352 px).
    // Marginesy zerujemy ręcznie, bo `container-fluid` ma je na `auto` i sam
    // zwężony kontener WYŚRODKOWAŁBY się - prawą krawędzią wjeżdżając pod panel.
    react_1.default.createElement(react_bootstrap_1.Container, { fluid: true, className: "py-2", style: isPanelOpen
            ? { width: `calc(100% - ${AddTypeModal_1.TYPES_PANEL_WIDTH}px)`, marginLeft: 0, marginRight: AddTypeModal_1.TYPES_PANEL_WIDTH }
            : undefined },
        react_1.default.createElement(AddTypeModal_1.AddTypeModal, { kind: addKind, editTarget: editTarget, data: data, contractTypeId: selectedContractTypeId, defaultMilestoneTypeId: selectedMilestoneTypeId, isSaving: isSaving, error: saveError, onClose: () => {
                setAddKind(null);
                setEditTarget(null);
            }, onSubmit: handleSave }),
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Col, { md: 12 },
                react_1.default.createElement(react_bootstrap_1.Card, { role: "region", "aria-label": title },
                    react_1.default.createElement(react_bootstrap_1.Card.Header, { className: "py-2 d-flex align-items-center gap-3 flex-wrap" },
                        react_1.default.createElement("span", { className: "small text-muted" }, "Poka\u017C do:"),
                        react_1.default.createElement(react_bootstrap_1.ToggleButtonGroup, { type: "radio", name: "types-tree-depth", size: "sm", value: depth, onChange: changeDepth }, DEPTH_LABELS.map(({ value, label }) => (react_1.default.createElement(react_bootstrap_1.ToggleButton, { key: value, id: `types-tree-depth-${value}`, "data-testid": "types-tree-depth", "data-depth": value, value: value, variant: "outline-secondary" }, label)))),
                        react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "switch", id: "types-tree-show-tasks", "data-testid": "types-tree-tasks-toggle", className: "mb-0", label: "Zadania", checked: showTasks, onChange: (event) => setShowTasks(event.currentTarget.checked) }),
                        isViewChanged && (react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "link", className: "p-0 small", "data-testid": "types-tree-reset", onClick: resetView }, "Zresetuj widok")),
                        react_1.default.createElement("span", { "data-testid": "types-tree-summary", className: "small text-muted" }, summaryText(layout.summary)),
                        selectedContractType?.status === "OLD" && (react_1.default.createElement("span", { "data-testid": "types-tree-retired", className: "small text-danger" }, "Ten typ umowy jest wycofany.")),
                        !showTasks && layout.summary.tasks.total > 0 && (react_1.default.createElement("span", { className: "small text-muted" }, "Licznik zada\u0144 zostaje na kaflu.")),
                        !canEdit && (react_1.default.createElement("span", { className: "small text-muted ms-auto", "data-testid": "types-tree-readonly" }, "Podgl\u0105d - zmiany wprowadza si\u0119 w panelu administracyjnym.")),
                        canEdit && (react_1.default.createElement("div", { className: "ms-auto d-flex gap-2" },
                            react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-success", disabled: selectedContractTypeId === null, onClick: () => {
                                    setSaveError(null);
                                    // Dodawanie zostaje oknem modalnym (decyzja 4 planu), a okno
                                    // i panel to dwie powłoki tego samego formularza - otwarty
                                    // panel przesłoniłby okno i przycisk wyglądałby na martwy.
                                    setEditTarget(null);
                                    setAddKind("milestoneType");
                                } }, "Dodaj kamie\u0144 milowy"),
                            react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-secondary", disabled: selectedContractTypeId === null, onClick: () => {
                                    setSaveError(null);
                                    setEditTarget(null);
                                    setAddKind("attachMilestoneType");
                                } }, "Podepnij istniej\u0105cy"),
                            react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-success", disabled: selectedContractTypeId === null, onClick: () => {
                                    setSaveError(null);
                                    setEditTarget(null);
                                    setAddKind("caseType");
                                } }, "Dodaj typ sprawy")))),
                    react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "p-2", style: { position: "relative" } },
                        react_1.default.createElement("div", { style: {
                                position: "absolute",
                                top: 8,
                                left: 8,
                                zIndex: 2,
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 6,
                            } },
                            react_1.default.createElement("div", { style: { maxWidth: 280 } },
                                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-secondary", className: "rounded-pill py-0 px-2 small", "aria-expanded": showLegend, "data-testid": "types-tree-legend", onClick: () => setShowLegend((current) => !current) },
                                    showLegend ? "▾" : "▸",
                                    " Legenda"),
                                showLegend && (react_1.default.createElement("div", { "data-testid": "types-tree-legend-items", className: "small text-muted", style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 2,
                                        marginTop: 4,
                                        padding: "6px 8px",
                                        borderRadius: 8,
                                        border: "1px solid #e9ecef",
                                        background: "rgba(255, 255, 255, 0.96)",
                                    } },
                                    react_1.default.createElement("span", null,
                                        react_1.default.createElement("svg", { width: "22", height: "8" },
                                            react_1.default.createElement("line", { x1: "0", y1: "4", x2: "22", y2: "4", stroke: "#198754", strokeWidth: "2.5" })),
                                        " ",
                                        "powstaje samo przy nowej umowie"),
                                    react_1.default.createElement("span", null,
                                        react_1.default.createElement("svg", { width: "22", height: "8" },
                                            react_1.default.createElement("line", { x1: "0", y1: "4", x2: "22", y2: "4", stroke: "#fd7e14", strokeWidth: "2.5", strokeDasharray: "6 4" })),
                                        " ",
                                        "oznaczone jako domy\u015Blne, ale bez szablonu - nie powstanie"),
                                    react_1.default.createElement("span", null,
                                        react_1.default.createElement("svg", { width: "22", height: "8" },
                                            react_1.default.createElement("line", { x1: "0", y1: "4", x2: "22", y2: "4", stroke: "#ced4da", strokeWidth: "1.5" })),
                                        " ",
                                        "zwyk\u0142e"),
                                    react_1.default.createElement("span", null,
                                        react_1.default.createElement("svg", { width: "16", height: "12" },
                                            react_1.default.createElement("rect", { x: "1", y: "1", width: "14", height: "10", rx: "2", fill: "#fff", stroke: "#adb5bd", strokeDasharray: "4 2" })),
                                        " ",
                                        "wy\u0142\u0105cznie jako podsprawa"),
                                    react_1.default.createElement("span", null,
                                        react_1.default.createElement("span", { style: {
                                                display: "inline-block",
                                                width: 7,
                                                height: 7,
                                                borderRadius: 4,
                                                background: "#6f42c1",
                                            } }),
                                        " ",
                                        "zadanie startowe - powstaje razem ze spraw\u0105")))),
                            react_1.default.createElement("div", { style: { maxWidth: 320 } },
                                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-secondary", className: "rounded-pill py-0 px-2 small", "aria-expanded": showExtras, "data-testid": "types-tree-extras-toggle", onClick: () => setShowExtras((current) => !current) },
                                    showExtras ? "▾" : "▸",
                                    " Nieprzypisane typy (",
                                    offerBranch.length + orphanMilestones.length + orphanCaseTypes.length,
                                    ")"),
                                showExtras && (react_1.default.createElement("div", { "data-testid": "types-tree-extras", className: "small", style: {
                                        marginTop: 4,
                                        padding: "6px 8px",
                                        borderRadius: 8,
                                        border: "1px solid #e9ecef",
                                        background: "rgba(255, 255, 255, 0.96)",
                                        // Trzy listy potrafią być długie - warstwa przewija
                                        // się sama, zamiast rosnąć poza płótno.
                                        maxHeight: 420,
                                        overflowY: "auto",
                                    } },
                                    react_1.default.createElement("div", { className: "fw-semibold" },
                                        "Kamienie ofertowe (",
                                        offerBranch.length,
                                        ")"),
                                    offerBranch.length === 0 ? (react_1.default.createElement("div", { className: "text-muted" }, "Brak.")) : (offerBranch.map(({ edge, milestoneType }) => (react_1.default.createElement("div", { key: milestoneType.id },
                                        react_1.default.createElement("code", null, edge.folderNumber),
                                        " ",
                                        milestoneType.name)))),
                                    react_1.default.createElement("div", { className: "fw-semibold mt-2" },
                                        "Kamienie bez powi\u0105zania z typem umowy (",
                                        orphanMilestones.length,
                                        ")"),
                                    orphanMilestones.length === 0 ? (react_1.default.createElement("div", { className: "text-muted" }, "Brak.")) : (orphanMilestones.map((type) => react_1.default.createElement("div", { key: type.id }, type.name))),
                                    react_1.default.createElement("div", { className: "fw-semibold mt-2" },
                                        "Typy spraw bez kamienia (",
                                        orphanCaseTypes.length,
                                        ")"),
                                    orphanCaseTypes.length === 0 ? (react_1.default.createElement("div", { className: "text-muted" }, "Brak.")) : (orphanCaseTypes.map((caseType) => (react_1.default.createElement("div", { key: caseType.id }, caseType.name)))))))),
                        react_1.default.createElement(TypesTreeGraph_1.TypesTreeGraph, { layout: layout, selectedNodeId: selectedNodeId, onNodeClick: (node) => {
                                // Kolumna zerowa przejęła rolę listy po lewej:
                                // klik w typ umowy przełącza gałąź, a nie zaznacza węzeł.
                                if (node.kind === "contractType") {
                                    selectContractType(node.entityId);
                                    return;
                                }
                                // Przy otwartym panelu klik w sąsiedni kafel PODMIENIA
                                // jego zawartość - panel nie zamyka się i nie otwiera
                                // od nowa. Dopóki panel jest zamknięty, zostaje wejście
                                // dwuklikiem: pierwszy klik zaznacza, drugi otwiera.
                                setSelectedNodeId(node.id);
                                if (!canEdit)
                                    return;
                                if (isPanelOpen || node.id === selectedNodeId)
                                    openEditFor(node.id);
                            }, onToggleCollapse: toggleCollapse })))))));
}
